// Modal.js
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

const ReusableModal = ({
    isOpen,
    onClose,
    children,
    bgColor,
    borderRadius,
    closeTimer,
    setShowPaymentModal,
}) => {
    const [modalRoot, setModalRoot] = useState(null);
    const modalRef = useRef(null);

    useEffect(() => {
        const modalRootElement = document.createElement("div");
        document.body.appendChild(modalRootElement);
        setModalRoot(modalRootElement);

        return () => {
            document.body.removeChild(modalRootElement);
        };
    }, []);
//--------If closeTimer property is passed, the modal will close automatically after the specified time. @Sanket
    useEffect(() => {
        if (closeTimer) {
            setTimeout(() => {
                onClose();
            }, closeTimer);
        }
    }, [closeTimer, onClose]);
//---------If the modal is open and the user clicks outside the modal, the modal will close. @Sanket
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    if (!isOpen) return null;
//---------Devs can pass the properties to style the modal. @Sanket
    const reusableModalStyles = {
        backgroundColor: bgColor,
        borderRadius: borderRadius,
    };
    return modalRoot
        ? ReactDOM.createPortal(
              <div className="reusable-modal-overlay">
                  <div
                      className="reusable-modal"
                      style={reusableModalStyles}
                      ref={modalRef}
                  >
                      <div className="reusable-modal-content">{children}</div>
                      {/* <button onClick={onClose}>Close</button> */}
                  </div>
              </div>,
              modalRoot
          )
        : null;
};

export default ReusableModal;
